import "./upgrade.css";

import * as routes from "../constants/routes";

import { Elements, StripeProvider } from "react-stripe-elements";
import React, { Component } from "react";

import AuthService from "../services/auth";
import SubscriptionForm from "../components/SubscriptionForm";
import { compose } from "recompose";
import config from "../config";
import { connect } from "react-redux";
import gif from "../static/images/loader.gif";
import withAuthorization from "../components/withAuthorization";
import { withRouter } from "react-router-dom";

class subscribeSugarBaby extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlayVisible: false,
      lookingForTexts: {
        sugar_baby_a: "sugarbabies",
        sugar_baby_m: "sugarbabies",
        sugar_baby_f: "sugarbabies",
        sugar_parent_a: "sugar mommies or daddies",
        sugar_parent_m: "sugar daddies",
        sugar_parent_f: "sugar mommies"
      }
    };
  }

  componentDidMount() {
    const { setCurrentPage } = this.props;
    if (!AuthService.isLoggedIn()) {
      this.props.history.push(routes.JOIN);
    } else {
      setCurrentPage(routes.SUBSCRIBE);
    }
  }

  showOverlay(show = true) {
    this.setState({
      overlayVisible: show
    });
  }

  render() {
    const { lookingForTexts, overlayVisible } = this.state;
    const { ucdUser } = this.props;
    const lookingForText = lookingForTexts[ucdUser.lookingFor];
    return (
      <div className="container search">
        {AuthService.isLoggedIn() && (
          <div className="row">
            <div className="col col-12 upgrade">
              <div className="intro">
                <p className={"first-line"}>
                  Hey <span className={"bold"}>{ucdUser.name}</span>,
                </p>
                <p>
                  <span className={"bold"}>RECEIVE $50 NOW</span> JUST CONVINCE
                  A {lookingForText}
                </p>
                <p>TO HAVE A DATE WITH YOU</p>
              </div>
              <div className="payment">
                <div className="payment-methods">
                  <StripeProvider apiKey={config.stripeConfig.apiKey}>
                    <Elements>
                      <SubscriptionForm
                        ucdUser={ucdUser}
                        showOverlay={show => this.showOverlay(show)}
                      />
                    </Elements>
                  </StripeProvider>
                  <div className={`overlay ${overlayVisible ? "visible" : ""}`}>
                    <img src={gif} alt="Loader" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ucdUser: state.sessionState.ucdUser,
  authUser: state.sessionState.authUser
});

const mapDispatchToProps = dispatch => ({
  onSetAuthUser: (authUser, ucdUser) =>
    dispatch({ type: "AUTH_USER_SET", authUser, ucdUser }),
  setCurrentPage: page => dispatch({ type: "SET_CURRENT_PAGE", page })
});

const authCondition = authUser => !!authUser;

export default compose(
  withAuthorization(authCondition),
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(subscribeSugarBaby);



// WEBPACK FOOTER //
// ./src/pages/subscribeSugarBaby.js